"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownValue = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const DropdownValue = ({ selectProps, selectedCount, isLoading, }) => {
    const countVisible = selectedCount && selectedCount > 0 && !isLoading;
    const value = React.useMemo(() => `${selectProps.placeholder} ${countVisible ? '(' + selectedCount + ')' : ''}`, [countVisible, selectProps.placeholder, selectedCount]);
    return (0, jsx_runtime_1.jsx)("div", { className: "multiselect-dropdown-value", children: value });
};
exports.DropdownValue = DropdownValue;
